import React, { useState } from 'react';
import axiosClient from '../../axios_client';

const AddAdminPackages = ({ isOpen, onClose, onPackageAdded }) => {
    const [packageName, setPackageName] = useState('');
    const [description, setDescription] = useState('');
    const [shortDescriptions, setShortDescriptions] = useState(['']);
    const [imageFile, setImageFile] = useState(null);
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleShortDescriptionChange = (index, value) => {
        const newDescs = [...shortDescriptions];
        newDescs[index] = value;
        setShortDescriptions(newDescs);
    };

    const addShortDescription = () => {
        setShortDescriptions([...shortDescriptions, '']);
    };

    const removeShortDescription = (index) => {
        const newDescs = shortDescriptions.filter((_, i) => i !== index);
        setShortDescriptions(newDescs);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!packageName || !description || shortDescriptions.length === 0) {
            setError('Please fill all required fields.');
            return;
        }

        const formData = new FormData();
        formData.append('package_name', packageName);
        formData.append('description', description);
        formData.append('short_descriptions', JSON.stringify(shortDescriptions));
        if (imageFile) {
            formData.append('Image', imageFile);
        }

        try {
            await axiosClient.post('/packages', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            onPackageAdded();
            onClose();
            // Reset form
            setPackageName('');
            setDescription('');
            setShortDescriptions(['']);
            setImageFile(null);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to add package');
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 sm:px-6">
            <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-xs sm:max-w-md max-h-[90vh] overflow-auto">
                <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-[#12392B]">
                    Add New Package
                </h2>
                {error && (
                    <p className="text-red-500 text-sm sm:text-base mb-3 sm:mb-4">
                        {error}
                    </p>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="packageName"
                        >
                            Package Name *
                        </label>
                        <input
                            type="text"
                            id="packageName"
                            value={packageName}
                            onChange={(e) => setPackageName(e.target.value)}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                            required
                            aria-label="Package Name"
                        />
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="description"
                        >
                            Description *
                        </label>
                        <textarea
                            id="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                            rows="4"
                            required
                            aria-label="Description"
                        />
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="shortDescriptions"
                        >
                            Short Descriptions *
                        </label>
                        {shortDescriptions.map((desc, index) => (
                            <div key={index} className="flex mb-2 items-center">
                                <input
                                    type="text"
                                    value={desc}
                                    onChange={(e) => handleShortDescriptionChange(index, e.target.value)}
                                    className="flex-grow p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                                    required
                                    aria-label={`Short Description ${index + 1}`}
                                />
                                <button
                                    type="button"
                                    onClick={() => removeShortDescription(index)}
                                    className="ml-2 bg-[#B91C1C] text-white p-1 sm:p-2 rounded hover:bg-red-700 transition text-sm sm:text-base"
                                    disabled={shortDescriptions.length === 1}
                                >
                                    &times;
                                </button>
                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={addShortDescription}
                            className="mt-2 bg-[#12392B] text-white p-2 sm:p-3 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition text-sm sm:text-base"
                        >
                            Add Short Description
                        </button>
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="image"
                        >
                            Image (JPEG/PNG)
                        </label>
                        <input
                            type="file"
                            id="image"
                            accept="image/jpeg,image/png"
                            onChange={(e) => setImageFile(e.target.files[0])}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded text-sm sm:text-base"
                            aria-label="Upload Image"
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white p-2 sm:p-3 rounded hover:bg-gray-600 transition text-sm sm:text-base"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-[#12392B] text-white p-2 sm:p-3 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition text-sm sm:text-base"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddAdminPackages;